<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row mt-5">
            <div class="col-md-6 d-flex justify-content-end align-items-center">
                <h4>{{ labels.fechaContabilizacion }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start" v-if="fechasParamContab.length >= 1">
                <select v-model="fechaContabilizacion" class="form-control">
                    <option value="">Seleccione...</option>
                    <option v-for="item in fechasParamContab" :key="item.id" :value="item.fecha_contabilizacion"> {{ item.fecha_contabilizacion }} </option>
                </select>
            </div>
            <div class="col-md-2 d-flex justify-content-start" v-else>
                <input type="month" v-model="fechaContabilizacion" class="form-control">
            </div>
            <div class="col-md-2 d-flex justify-content-start" v-if="fechasParamContab.length >= 1">
                <b-button
                    v-if="fechasParamContab?.length >= 1"
                    class="table-toolbar-add-btn"
                    @click="creaParamContab"
                    title="Crear nueva parametrización"
                >

                    <font-awesome-icon
                        :icon="['fas', 'plus']"
                    />

                </b-button>
            </div>
        </div>
        <div class="row mt-2" v-if="showNewContab">
            <div class="col-md-6 d-flex justify-content-end align-items-center">
                <h4>{{ labels.newFechaContab }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <input type="month" v-model="newFechaContab" class="form-control">
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <b-button
                    class="table-toolbar-delete-btn"
                    variant="danger"
                    @click="deleteParamContab"
                    title="Cancelar"
                >
                    <font-awesome-icon
                        :icon="['fas', 'trash']"
                    />
                </b-button>
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <b-button type="button" id="create-btn" @click="procesarContabilizacion">{{ labels.consultar }}</b-button>
        </div>
        <div class="table col-md-12 mt-4" v-if="lstCuentasFecha.length == 0 && !showTblNoData">
            <table class="tblEstandar">
                <thead>
                    <tr>
                        <th class="thTbl" v-for="(header, index) in headers" :key="index">{{ header }}</th>
                        <th class="thTbl">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in rows" :key="index">
                        <td>
                            <select v-model="row.selTipoContrato">
                                <option value="">Seleccione...</option>
                                <option v-for="contrato in tipoContrato" :key="contrato.id" :value="contrato.tipo_contrato">{{ contrato.descripcion }}</option>
                            </select>
                        </td>
                        <td>
                            <select v-model="row.selTipoActivo">
                                <option value="">Seleccione...</option>
                                <option v-for="activo in tipoActivo" :key="activo.id" :value="activo.tipo_activo">{{ activo.descripcion }}</option>
                            </select>
                        </td>
                        <td>
                            <select v-model="row.selCampoOrigen" class="form-control">
                                <option value="">Seleccione...</option>
                                <option value="1">1-Total Valor Canon</option>
                                <option value="2">2-Pasivo Inicial</option>
                                <option value="3">3-Cambio pasivo</option>
                                <option value="4">4-Total Pago Capital</option>
                                <option value="5">5-Total Pago Intereses</option>
                                <option value="6">6-Pasivo Final</option>
                                <option value="7">7-Activo Derecho de uso Bruto</option>
                                <option value="8">8-Total Gasto Amortizacion</option>
                                <option value="9">9-Amortización acumulada</option>
                                <option value="10">10-Baja de Activos</option>
                            </select>
                        </td>
                        <td>
                            <select v-model="row.selCentroCostos">
                                <option value="">No aplica...</option>
                                <option v-for="cc in centroCostos" :key="cc.id" :value="cc.codigo">{{ cc.descripcion }}</option>
                            </select>
                        </td>
                        <td>
                            <select v-model="row.selCentroFijo" class="form-control">
                                <option value="">Seleccione...</option>
                                <option value="C">Contrato</option>
                                <option value="F">Fijo</option>
                            </select>
                        </td>
                        <td>
                            <input type="number" v-model="row.selCuenta">
                        </td>
                        <td>
                            <input type="text" v-model="row.nameCuenta">
                        </td>
                        <td>
                            <select v-model="row.selTipoNaturaleza">
                                <option value="">Seleccione...</option>
                                <option value="D">Débito</option>
                                <option value="C">Crédito</option>
                            </select>
                        </td>
                        <td>
                            <button class="btn btn-danger" @click="removeRow(index)">Eliminar</button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="actions">
                <button class="btn btn-warning" @click="addRowOrigen">Agregar Origen</button>
                <button class="btn btn-success" @click="addRow">Agregar Fila</button>
                <button class="btn-save" @click="saveData">Guardar Datos</button>
            </div>
            
            <!-- <div v-if="savedData.length > 0" style="margin-top: 30px;">
                <h2>Datos Guardados</h2>
                <pre>{{ savedData }}</pre>
            </div> -->
        </div>
        <div class="table col-md-12 mt-4" v-if="lstCuentasFecha.length >= 1 && !showTblData">
            <table class="tblEstandar">
                <thead>
                    <tr>
                        <th class="thTbl" v-for="(header, index) in headers" :key="index">{{ header }}</th>
                        <th class="thTbl">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in lstCuentasFecha" :key="index">
                        <td>
                            <select v-model="row.tipo_contrato">
                                <option value="">Seleccione...</option>
                                <option v-for="contrato in tipoContrato" :key="contrato.id" :value="contrato.tipo_contrato">{{ contrato.descripcion }}</option>
                            </select>
                        </td>
                        <td>
                            <select v-model="row.tipo_activo">
                                <option value="">Seleccione...</option>
                                <option v-for="activo in tipoActivo" :key="activo.id" :value="activo.tipo_activo">{{ activo.descripcion }}</option>
                            </select>
                        </td>
                        <td>
                            <select v-model="row.campo_origen">
                                <option value="">Seleccione...</option>
                                <option value="1">1-Total Valor Canon</option>
                                <option value="2">2-Pasivo Inicial</option>
                                <option value="3">3-Cambio pasivo</option>
                                <option value="4">4-Total Pago Capital</option>
                                <option value="5">5-Total Pago Intereses</option>
                                <option value="6">6-Pasivo Final</option>
                                <option value="7">7-Activo Derecho de uso Bruto</option>
                                <option value="8">8-Total Gasto Amortizacion</option>
                                <option value="9">9-Amortización acumulada</option>
                                <option value="10">10-Baja de Activos</option>
                            </select>
                        </td>
                        <td>
                            <select v-model="row.codigo_centro_costo">
                                <option value=0></option>
                                <option v-for="cc in centroCostos" :key="cc.id" :value="cc.codigo">{{ cc.descripcion }}</option>
                            </select>
                        </td>
                        <td>
                            <select v-model="row.centro_fijo">
                                <option value="C">Contrato</option>
                                <option value="F">Fijo</option>
                            </select>
                        </td>
                        <td>
                            <input type="number" v-model="row.nro_cuenta">
                        </td>
                        <td>
                            <input type="text" v-model="row.nombre_cuenta">
                        </td>
                        <td>
                            <select v-model="row.naturaleza">
                                <option value="">Seleccione...</option>
                                <option value="D">Débito</option>
                                <option value="C">Crédito</option>
                            </select>
                        </td>
                        <td>
                            <button class="btn btn-danger" @click="removeNewRow(index,row.id)">Eliminar</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="actions">
                <!-- <button class="btn btn-warning" @click="addRowOrigen">Agregar Origen</button> -->
                <button class="btn btn-success" @click="addRowTblData">Agregar Fila</button>
                <button class="btn-save" @click="saveDataInfo">Guardar Datos</button>
            </div>
            <!-- <pre>{{ lstCuentasFecha }}</pre> -->
        </div>
    </div>
</template>

<script>
import CentroCostos from '../../../services/CentroCostos'
import TipoActivo from '../../../services/TipoActivo'
import TipoContrato from '../../../services/TipoContrato'
import ParametrosContabilizacion from '../../../services/ParametrosContabilizacion'

export default {
    name : 'ParametrosContabilizacion',
    data: () => ({
        fechaContabilizacion : '',
        fechasParamContab : [],
        tipoContrato : [],
        tipoActivo : [],
        centroCostos : [],
        headers: [
            'Tipo contrato', 
            'Tipo activo', 
            'Campo origen', 
            'Centro costo',
            'Centro Aplicar',
            'Cuenta', 
            'Descripción', 
            'Naturaleza', 
        ],
        cuentas: [
            { numero: '54235410236', nombre: 'Cuenta Corriente Principal' },
            { numero: '54203854752', nombre: 'Cuenta de Ahorros' },
            { numero: '54204185697', nombre: 'Cuenta Inversión' }
        ],
        rows: [{
            selTipoContrato: '',
            selTipoActivo: '',
            selCampoOrigen: '',
            selCuenta: '',
            nameCuenta: '',
            selTipoNaturaleza: '',
            selCentroCostos: '',
            selCentroFijo: ''
        }],
        savedData: [],
        lstCuentasFecha : [],
        showTblNoData : true,
        showTblData : true,
        showNewContab : false,
        showBtnParamCont : false,
        newFechaContab : ''
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Parámetros de contabilización",
                    fechaContabilizacion : 'Fecha contabilización',
                    newFechaContab : 'Nueva contabilización',
                    consultar : 'Consultar',
                    guardar : 'Guardar'
                }
            }else{
                return {
                    title: "Accounting parameters",
                    fechaContabilizacion : 'Posting date',
                    newFechaContab : 'New posting',
                    consultar : 'Consult',
                    guardar : 'Save'
                }
            }
        }
    },
    methods: {
        procesarContabilizacion(){
            if(this.fechaContabilizacion != ''){
                
                ParametrosContabilizacion.getParametrosContabilizacionByFechaContb(this.fechaContabilizacion)
                .then((res) => {
                    // console.log(res.data.listParamtsContByFec);
                    this.lstCuentasFecha = res.data.listParamtsContByFec
                    if(this.lstCuentasFecha.length != 0){
                        
                        this.showTblData = false
                        this.showTblNoData = true
                    }else{
                        this.showTblNoData = false
                        this.showTblData = true
                    }
                })
                .catch((err) => console.log(err))

            }else{
                this.$toast.error('Seleccionar la fecha contabilización.')
            }
        },
        guardarContabilizacion(){
            if(this.newFechaContab != ''){

                // const lastFecha = this.fechasParamContab[this.fechasParamContab.length - 1]
                const lastFecha = this.fechasParamContab[0]

                const info = {
                    'newFechaParCon' : this.newFechaContab,
                    'lastFechaParCon' : lastFecha.fecha_contabilizacion,
                    'idUser' : this.$store.state.userId,
                }
                // console.log(info);

                ParametrosContabilizacion.cargaLastPlantilla(info)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    location.reload()
                })
                .catch((err) => {
                    
                    if (!err.response) {
                        this.$toast.error('Error de conexión con el servidor')
                        return
                    }

                    const { status, data } = err.response

                    if (status === 400 || status === 500) {
                        this.$toast.error(data.message)
                    } else {
                        this.$toast.error('Error inesperado')
                    }
                })

            }else{
                this.$toast.error('Seleccionar la nueva fecha contabilización.')
            }
        },
        createOriginRow(){
            return {
                'selTipoContrato' : this.selTipoContrato,
                'selTipoActivo' : this.selTipoActivo,
                'selCampoOrigen' : this.selCampoOrigen,
                'selCuenta' : this.selCuenta,
                'nameCuenta' : this.nameCuenta,
                'selTipoNaturaleza' : this.selTipoNaturaleza,
                'selCentroCostos' : this.selCentroCostos,
                'selCentroFijo' : this.selCentroFijo
            };
        },
        createEmptyRow() {

            const lastRow = this.rows.length ? this.rows[this.rows.length - 1] : null;
            // console.log(lastRow,'PPPPP');
            return {
                'selTipoContrato' : lastRow ? lastRow.selTipoContrato : '',
                'selTipoActivo' : lastRow ? lastRow.selTipoActivo : '',
                'selCampoOrigen' : lastRow ? lastRow.selCampoOrigen : '',
                'selCuenta' : this.selCuenta,
                'nameCuenta' : this.nameCuenta,
                'selTipoNaturaleza' : this.selTipoNaturaleza,
                'selCentroCostos' : this.selCentroCostos,
                'selCentroFijo' : this.selCentroFijo
            };
        },
        addRow() {
            this.rows.push(this.createEmptyRow());
        },
        removeRow(index) {
            // console.log(index);
            // console.log(this.lstCuentasFecha.length,'<-ROWS');
            // console.log(this.lstCuentasFecha,'<-OTRO');
            if (this.rows.length > 1) {
                this.rows.splice(index, 1);
            } else {
                this.$toast.error('Debe haber minimo una fila')
            }
        },
        removeNewRow(index,id) {
            // console.log(index);
            if (this.lstCuentasFecha.length > 1) {
                if(id){
                    // Eliminar registro de la BD

                    ParametrosContabilizacion.deleteParametrosContabilizacion(id)
                    .then((res) => {
                        this.$toast.success(res.data.message)
                        location.reload()
                    })
                    .catch((err) => console.log(err))
                }else{
                    // Elimina fila
                    this.lstCuentasFecha.splice(index, 1);
                }
            } else {
                this.$toast.error('Debe haber minimo una fila')
            }
        },
        addRowOrigen(){
            // console.log('addOrigen');
            this.rows.push(this.createOriginRow());
        },
        addRowTblData(){
            let newRow = {
                'selTipoContrato' : '',
                'selTipoActivo' : '',
                'selCampoOrigen' : '',
                'selCuenta' : '',
                'nameCuenta' : '',
                'selTipoNaturaleza' : '',
                'selCentroCostos' : '',
                'selCentroFijo' : '',
                'idUser' : this.$store.state.userId,
                'fechaContab' : this.fechaContabilizacion
            }
            this.lstCuentasFecha.push(newRow)
            // this.lstCuentasFecha.push(this.createRowEmpty)
        },
        /*createRowEmpty(){
            const lastRow = this.rows.length ? this.rows[this.rows.length - 1] : null;
            console.log(lastRow,'SSSSS');
            // return {
            //     'selTipoContrato' : lastRow ? lastRow.selTipoContrato : '',
            //     'selTipoActivo' : lastRow ? lastRow.selTipoActivo : '',
            //     'selCampoOrigen' : lastRow ? lastRow.selCampoOrigen : '',
            //     'selCuenta' : this.selCuenta,
            //     'nameCuenta' : this.nameCuenta,
            //     'selTipoNaturaleza' : this.selTipoNaturaleza,
            //     'selCentroCostos' : this.selCentroCostos
            // };
        },*/
        saveData() {
            const formattedData = this.rows.map(row => {
                // console.log(row,'EEE');
                return {
                    'tipoContrato' : row.selTipoContrato,
                    'tipoActivo' : row.selTipoActivo,
                    'campoOrigen' : row.selCampoOrigen,
                    'nroCuenta' : row.selCuenta,
                    'cuenta' : row.nameCuenta,
                    'naturaleza' : row.selTipoNaturaleza,
                    'centroCosto' : row.selCentroCostos,
                    'centroFijo' : row.selCentroFijo,
                    'idUser' : this.$store.state.userId,
                    'fechaContab' : this.fechaContabilizacion
                }
            });
            
            this.savedData = formattedData;
            
            ParametrosContabilizacion.createParametrosContabilizacion(this.savedData)
            .then((res) => {
                // console.log(res.data.message);
                this.$toast.success(res.data.message)
                location.reload()
            })
            .catch((err) => {
                if(err.response.status == 400){
                    this.$toast.error(err.response.data.message)
                }else{
                    this.$toast.error("Algo pasó, intentalo de nuevo")
                }
            })
        },
        saveDataInfo(){

            if(this.fechaContabilizacion != '' && this.newFechaContab != ''){
                this.guardarContabilizacion()
                return
            }
            // console.log(this.lstCuentasFecha);
            // console.log(this.lstCuentasFecha.length);
            if(this.lstCuentasFecha.length != 0){

                ParametrosContabilizacion.updateCreateParametrosContabilizacion(this.lstCuentasFecha)
                .then((res) => {
                    // console.log(res.data.message);
                    this.$toast.success(res.data.message)
                    location.reload()
                })
                .catch((err) => {
                    if(err.response.status == 400){
                        this.$toast.error(err.response.data.message)
                    }else{
                        this.$toast.error("Algo pasó, intentalo de nuevo")
                    }
                })

            }else{
                this.$toast.error('Debe agregar minimo un registro.')
            }
        },
        updateAccountName(index) {
            const selectedNumero = this.rows[index].selCuenta;
            const cuenta = this.cuentas.find(c => c.numero === selectedNumero);
            this.rows[index].nameCuenta = cuenta ? cuenta.nombre : '';
        },
        uptAccoNombre(index){
            // console.log(index);
            // console.log(this.rows);
            // console.log(this.lstCuentasFecha);
            const selNumero = this.lstCuentasFecha[index].nro_cuenta;
            const cuenta = this.cuentas.find(c => c.numero === selNumero);
            console.log(cuenta,'CUENTA');
            // console.log(this.rows);
            console.log(this.lstCuentasFecha[index].nameCuenta,'MMM',cuenta.nombre);
            this.lstCuentasFecha[index].nameCuenta = cuenta.nombre ? cuenta.nombre : 'AAA';
            console.log(this.lstCuentasFecha[index].nameCuenta,'KKKKK', cuenta.nombre);
        },
        listTipoContrato(){
            TipoContrato.getAllTipoContrato()
            .then((res) => {
                // console.log(res.data.listTipoContrato);
                this.tipoContrato = res.data.listTipoContrato

                // this.rows.forEach(row => {
                //     row.cells[0].options = this.tipoContrato;
                // });
            })
            .catch((e) => console.log(e))

            // TipoContrato.getAllTipoContrato()
            // .then((res) => {
            //     this.tipoContrato = res.data.listTipoContrato

            //     let lstTipoContrato = []
            //     let objTipoContrato = {}
            //     this.tipoContrato.forEach(row => {
            //         objTipoContrato = {
            //             value : row.codigo,
            //             text : row.descripcion
            //         }
            //         lstTipoContrato.push(objTipoContrato)

            //         this.rows.forEach(row => {
            //             row.cells[0].options = lstTipoContrato
            //         });
            //     })
            //     .catch((e) => console.log(e))
            // })
        },
        listTipoActivo(){
            TipoActivo.getAllTipoActivo()
            .then((res) => {
                // console.log(res.data.listTipoActivo);
                this.tipoActivo = res.data.listTipoActivo

                // this.rows.forEach(row => {
                //     row.cells[1].options = this.tipoActivo;
                // });
            })
            .catch((e) => console.log(e))

            // TipoActivo.getAllTipoActivo()
            // .then((res) => {
            //     // console.log(res.data.listTipoActivo);
            //     this.tipoActivo = res.data.listTipoActivo

            //     let lstTipoActivo = []
            //     let objTipoActivo = {}
            //     this.tipoActivo.forEach(row => {
            //         objTipoActivo = {
            //             value : row.codigo,
            //             text : row.descripcion
            //         }
            //         lstTipoActivo.push(objTipoActivo)
            //     })

            //     this.rows.forEach(row => {
            //         row.cells[1].options = lstTipoActivo
            //     });
            // })
            // .catch((e) => console.log(e))

        },
        /*listCampoOrigen(){
            const optCuenta = [
                { value: '10', text: 'Valor canon' },
                { value: '20', text: 'Pasivo inicial' },
                { value: '30', text: 'Cambio pasivo' },
                { value: '40', text: 'Gasto amortización' },
                { value: '50', text: 'Intereses' },
                { value: '60', text: 'Pasivo final' }
            ]

            // this.rows.forEach(row => {
            //     row.cells[2].options = optCuenta;
            // });
            console.log(optCuenta);
        },*/
        /*listCuentas(){

            const optCuenta = [
                { value: '54235410236', text: '54235410236' },
                { value: '49075368021', text: '49075368021' },
                { value: '39540252786', text: '39540252786' },
            ]
            console.log(optCuenta);

            // this.rows.forEach(row => {
            //     row.cells[3].options = optCuenta;
            // });
        },*/
        /*listNaturaleza(){

            const optNaturaleza = [
                {      
                    value: 'D', text: 'Débito'
                },
                {
                    value: 'C', text: 'Crédito',
                }
            ]
            console.log(optNaturaleza);

            // this.rows.forEach(row => {
            //     row.cells[5].options = optNaturaleza;
            // });
        },*/
        listCentroCosto(){
            CentroCostos.getAllCentroCostos()
            .then((res) => {
                // console.log(res.data.listCentroCostos);
                this.centroCostos = res.data.listCentroCostos

                // let lstcentroCostos = []
                // let objCentroCost = {}
                // this.centroCostos.forEach(row => {
                //     objCentroCost = {
                //         value : row.codigo,
                //         text : row.descripcion
                //     }
                //     lstcentroCostos.push(objCentroCost)
                // })

                // this.rows.forEach(row => {
                //     row.cells[6].options = lstcentroCostos
                // });
            })
            .catch((e) => console.log(e))
        },
        creaParamContab(){
            this.showNewContab = true //Crear una nueva contabilizacion

            const lastFecha = this.fechasParamContab[0]

            ParametrosContabilizacion.getParametrosContabilizacionByFechaContb(lastFecha.fecha_contabilizacion)
            .then((res) => {
                // console.log(res.data.listParamtsContByFec);
                this.lstCuentasFecha = res.data.listParamtsContByFec
                if(this.lstCuentasFecha.length != 0){
                    this.fechaContabilizacion = lastFecha.fecha_contabilizacion
                    this.showTblData = false
                    this.showTblNoData = true
                }else{
                    this.showTblNoData = false
                    this.showTblData = true
                }
            })
            .catch((err) => console.log(err))
        },
        deleteParamContab(){
            this.showNewContab = false //Quita la fila para crear una nueva contabilizacion
        }
    },
    mounted(){
        this.listTipoContrato()
        this.listTipoActivo()
        // this.listNaturaleza()
        this.listCentroCosto()
        // this.listCampoOrigen()
        // this.listCuentas()

        ParametrosContabilizacion.getAllFechasParametrosContabilizacion()
        .then((res) => {
            // console.log(res.data.lstFechParamContab);
            this.fechasParamContab = res.data.lstFechParamContab
        })
        .catch((err) => console.log(err))
    },
    watch:{
        fechaContabilizacion(valNew){
            const lastFecha = this.fechasParamContab[0]
            
            if(valNew == ""){

                this.lstCuentasFecha = []
                this.showNewContab = ""

            }else if(valNew < lastFecha.fecha_contabilizacion){

                this.showNewContab = ""
                this.newFechaContab = ""

                ParametrosContabilizacion.getParametrosContabilizacionByFechaContb(this.fechaContabilizacion)
                .then((res) => {
                    // console.log(res.data.listParamtsContByFec);
                    this.lstCuentasFecha = res.data.listParamtsContByFec
                    if(this.lstCuentasFecha.length != 0){
                        this.showTblData = false
                        this.showTblNoData = true
                    }else{
                        this.showTblNoData = false
                        this.showTblData = true
                    }
                })
                .catch((err) => console.log(err))

            }
        }
    }
}
</script>

<style>
.tblContab {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.tblContainer {
    max-width: 1200px;
    margin: 0 auto;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
}
/* h1 {
    color: #2c3e50;
    text-align: center;
    margin-bottom: 30px;
} */
/* table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
} */
th, td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
    border: 1px solid #f0f0f0;
}
.thTbl {
    /* background-color: #2c3e50; */
    background-color: #f0f0f0;
    color: rgb(105, 105, 105);
    font-weight: 700;
}
/* tr:nth-child(even) {
    background-color: #f8faf8;
}
tr:hover {
    background-color: #f1f8fe;
} */
select, input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
}
select:focus, input:focus {
    outline: none;
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}
.btn {
    background-color: #3498db;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    margin-right: 10px;
    transition: background-color 0.3s;
}
.btn:hover {
    background-color: #2980b9;
}
.btn-save {
    background-color: #2c3e50;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    margin-right: 10px;
    transition: background-color 0.3s;
}
.btn-save:hover{
    background-color: #1c2127;
}
.btn-danger {
    background-color: #e74c3c;
}
.btn-danger:hover {
    background-color: #c0392b;
}
.btn-success {
    background-color: #2ecc71;
}
.btn-success:hover {
    background-color: #27ae60;
}
.actions {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}
</style>
